import React from 'react';
import { TextStyle } from '@superops/ui-design-system';

export const TextCell = (props) => {
  const { cell } = props;

  if (cell?.value) {
    return (
      <div className="ellipsis">
        <TextStyle>{cell?.value}</TextStyle>
      </div>
    );
  }
  return <TextStyle>NA</TextStyle>;
};
